import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

interface HeroSectionProps {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonLink: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ title, subtitle, buttonText, buttonLink }) => {
  return (
    <section className="hero-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <h1>{title}</h1>
            <p className="lead mb-4">{subtitle}</p>
            <Button 
              href={buttonLink} 
              variant="secondary" 
              size="lg" 
              className="px-4 py-2"
            >
              {buttonText}
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
